import Image from 'components/common/Image';
import { DEFAULT_LINK_POST_PLACEHOLDER_IMAGE } from 'utils/constants';
import { regexMap } from 'utils/constants/regex';
import getMaxString from 'utils/getMaxString';
import { ILinkPostContent } from './ILinkpostContent';

import {
  CoverImg,
  LinkBlockWrap,
  LinkImageBackground,
  LinkImageWrapper,
  LinkText,
  LinkTitle,
  LinkWrap,
  WheelMarkIconWrap,
} from './LinkpostContent.styles';

const LinkpostContent = ({
  linkImage,
  linkTitle,
  linkHost,
  description,
}: ILinkPostContent) => {
  return (
    <LinkWrap>
      <LinkImageWrapper>
        {regexMap.urlImg.test(linkImage) &&
        linkImage !== DEFAULT_LINK_POST_PLACEHOLDER_IMAGE &&
        linkImage.startsWith('https') ? (
          <LinkImageBackground>
            <Image
              src={linkImage}
              alt={getMaxString(description, 8)}
              width={550}
              height={366}
              isLoader
              unoptimized
              priority
            />
          </LinkImageBackground>
        ) : (
          <CoverImg>
            <WheelMarkIconWrap>
              <Image
                src="/assets/img/tireTrace.png"
                alt="tire trace"
                width={550}
                height={366}
                unoptimized
                priority
              />
            </WheelMarkIconWrap>
          </CoverImg>
        )}
      </LinkImageWrapper>

      <LinkBlockWrap>
        <LinkTitle>{linkTitle}</LinkTitle>
        <LinkText>{linkHost}</LinkText>
      </LinkBlockWrap>
    </LinkWrap>
  );
};

export default LinkpostContent;
